import React from 'react';
import { CheckCircleIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import { useForm } from './provider';

export const SuccessPage = () => {
  const { state, chargeData } = useForm();
  const { member, success_redirect_path, offlinePayment } = state;
  const currentChargeData = chargeData();

  return (
    <div className="p-8 text-center">
      {/* Success Animation */}
      <div className="relative inline-flex">
        <div className="absolute inset-0 bg-emerald-200 rounded-full animate-ping opacity-25"></div>
        <div className="relative w-20 h-20 bg-gradient-to-br from-emerald-400 to-green-500 rounded-full flex items-center justify-center shadow-lg shadow-emerald-500/30">
          <CheckCircleIcon className="w-10 h-10 text-white" />
        </div>
      </div>

      {/* Success Message */}
      <h2 className="mt-6 text-2xl font-bold text-gray-900">Payment Successful!</h2>
      <p className="mt-2 text-gray-500">
        {offlinePayment
          ? 'The offline payment has been recorded successfully.'
          : 'The payment has been processed successfully.'}
      </p>

      {/* Payment Summary */}
      <div className="mt-6 inline-block bg-emerald-50 rounded-xl px-6 py-4 border border-emerald-200">
        <p className="text-sm text-emerald-600 font-medium">Amount Paid</p>
        <p className="text-3xl font-bold text-emerald-700">${currentChargeData.total}</p>
        <p className="text-xs text-emerald-600 mt-1">for {member.user?.first_name} {member.user?.last_name}</p>
      </div>

      {/* What's Next */}
      <div className="mt-8 text-left bg-gray-50 rounded-xl p-5 border border-gray-200">
        <p className="text-sm font-semibold text-gray-900 mb-3">What happens next?</p>
        <ul className="space-y-2">
          <li className="flex items-start gap-2">
            <svg className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-sm text-gray-600">
              {offlinePayment
                ? 'Invoice(s) have been marked as paid'
                : 'A receipt has been sent to the member\'s email'}
            </span>
          </li>
          <li className="flex items-start gap-2">
            <svg className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-sm text-gray-600">The member's balance has been updated</span>
          </li>
          <li className="flex items-start gap-2">
            <svg className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-sm text-gray-600">Transaction recorded in payment history</span>
          </li>
        </ul>
      </div>

      {/* Actions */}
      <div className="mt-8 flex flex-col gap-3">
        <a
          href={success_redirect_path}
          className="inline-flex items-center justify-center gap-2 w-full py-4 px-6 rounded-xl text-white font-semibold bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700 shadow-lg shadow-emerald-500/25 transition-all duration-200"
        >
          <span>Back to Member Profile</span>
          <ArrowRightIcon className="w-5 h-5" />
        </a>
      </div>

      {/* Confetti-like decoration */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-10 left-10 w-2 h-2 bg-emerald-300 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
        <div className="absolute top-20 right-20 w-3 h-3 bg-green-300 rounded-full animate-bounce" style={{ animationDelay: '0.3s' }}></div>
        <div className="absolute bottom-10 left-20 w-2 h-2 bg-emerald-400 rounded-full animate-bounce" style={{ animationDelay: '0.5s' }}></div>
      </div>
    </div>
  );
};
